import BaseCheckbox from '@carvana/showroom-forms/Checkbox';
import type { CheckboxProps } from '@carvana/showroom-forms/Checkbox/Checkbox';
import type React from 'react';
import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import SearchSource from '~/constants/SearchSource';
import SearchEventsDataContext from '~/contexts/SearchEventsDataContext';

const Checkbox: React.FC<CheckboxProps> = styled(BaseCheckbox).attrs({
  className: 'mb-0'
})`
  .checkbox__label {
    color: var(--cvna-color-blue-6);
    width: 100%;
  }
`;

type OwnProps = {
  facet: string;
  filter: string | number;
} & CheckboxProps;

const FilterCheckbox = ({
  checked,
  facet,
  filter,
  onChange,
  ...rest
}: OwnProps) => {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const [isChecked, setChecked] = useState(checked);

  const onChangeHandler: React.ChangeEventHandler<HTMLInputElement> = ev => {
    setChecked(v => !v);

    const t = setTimeout(() => {
      setSearchSource(SearchSource.Facet);
      if (onChange) onChange(ev);
    }, 0);

    return () => {
      clearTimeout(t);
    };
  };

  // Synchronize local state with global state
  useEffect(() => {
    setChecked(checked);
  }, [checked]);

  return (
    <Checkbox
      checked={isChecked}
      data-analytics-id={facet}
      data-analytics-attributes={JSON.stringify({ [facet]: filter })}
      onChange={onChangeHandler}
      {...rest}
    />
  );
};

export default FilterCheckbox;
